import queryString from 'query-string';
import { deleteAPI, getAPI, postAPI, putAPI } from './base/api';
import { routes } from './base/apiRoutes';

const handle401 = e => {
  if (e.response && e.response.status === 401) {
    // if (e.response && [401, 403].includes(e.response.status)) {
    localStorage.setItem('Authorization', '');
    window.location = window.origin;
  }

  throw e;
  // return Promise.reject(e);
};

export const createUser = async data => {
  return postAPI(routes.backend.user.create, data).catch(e => {
    return handle401(e);
  });
};

export const getUserDetailByUserId = async id => {
  return getAPI(`${routes.backend.user.getUserByUserId}${id}`).catch(e => {
    return handle401(e);
  });
};

// Estates
export const addEstate = async data => {
  return postAPI(routes.backend.estate.add, data).catch(e => {
    return handle401(e);
  });
};

export const getEstates = async () => {
  return getAPI(routes.backend.estate.all).catch(e => {
    return handle401(e);
  });
};

// Lot
export const createLot = async data => {
  return postAPI(routes.backend.lot.base, data).catch(e => {
    return handle401(e);
  });
};

export const getLots = async (params = {}) => {
  const query = queryString.stringify(params);
  const suffix = query ? `?${query}` : '';

  return getAPI(`${routes.backend.lot.base}${suffix}`).catch(e => {
    return handle401(e);
  });
};

export const getAllLots = async ({ limit = 20, page = 1, search }) => {
  let url = `${routes.backend.lot.getAllLots}?limit=${limit}&page=${page}`;

  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  return getAPI(url).catch(e => {
    return handle401(e);
  });
};

export const getLotById = async (id, media = true) => {
  return getAPI(`${routes.backend.lot.base}${id}?media=${media}`).catch(e => {
    return handle401(e);
  });
};

export const preProcessUpdate = async (data, id) => {
  return putAPI(`${routes.backend.lot.pre_process_update}${id}`, data).catch(e => {
    return handle401(e);
  });
};

export const updateLot = async (data, id) => {
  return putAPI(`${routes.backend.lot.base}${id}`, data).catch(e => {
    return handle401(e);
  });
};

// Process Stage
export const insertOrUpdateLotProcessStep = async (data, id) => {
  return putAPI(`${routes.backend.lot.insertOrUpdateLotProcessStep}${id}`, data).catch(e => {
    return handle401(e);
  });
};

export const insertOrUpdateSingleLotProcessStep = async ({ data, lot_id, process_step_id }) => {
  return putAPI(`${routes.backend.lot.insertOrUpdateSingleLotProcessStage(lot_id)}${process_step_id}`, data).catch(
    e => {
      return handle401(e);
    }
  );
};

export const updateSingleLotProcessStep = async ({ data, lot_id, process_step_id }) => {
  return putAPI(`${routes.backend.lot.updateSingleLotProcessStage(lot_id)}${process_step_id}`, data).catch(e => {
    return handle401(e);
  });
};

export const addProcessStep = async (lotId, data) => {
  return putAPI(routes.backend.lot.addOrDeleteProcessStep(lotId), data).catch(e => {
    return handle401(e);
  });
};

export const deleteProcessStep = async (lotId, data) => {
  return deleteAPI(routes.backend.lot.addOrDeleteProcessStep(lotId), data).catch(e => {
    return handle401(e);
  });
};

// Process Check
export const insertOrUpdateFermentationProcessCheck = async (data, lotId, processStepId) => {
  return postAPI(`${routes.backend.lot.insertOrUpdateFermentationProcessCheck(lotId, processStepId)}`, data).catch(
    e => {
      return handle401(e);
    }
  );
};

export const endFermentation = async (lotId, processStepId, data) => {
  return putAPI(`${routes.backend.lot.endFermentation(lotId, processStepId)}`, data).catch(e => {
    return handle401(e);
  });
};

export const changeLotStage = async (lotId, data) => {
  return putAPI(`${routes.backend.lot.changeLotStage(lotId)}`, data).catch(e => {
    return handle401(e);
  });
};

export const updatePreProcessData = async (data, id) => {
  return putAPI(routes.backend.lot.updatePreProcessData(id), data).catch(e => {
    return handle401(e);
  });
};

// Drying Stage API
export const getDryingLotsWithActiveBeds = async (query, page, limit) => {
  return getAPI(
    `${routes.backend.drying_stage.get_drying_lots_with_active_beds}?search=${query}&page=${page}&limit=${limit}`
  ).catch(e => {
    return handle401(e);
  });
};

export const startDrying = async (lot_id, data) => {
  return postAPI(routes.backend.drying_stage.start_drying(lot_id), data).catch(e => {
    return handle401(e);
  });
};

export const getDryingBedsOfLot = async lot_id => {
  return getAPI(routes.backend.drying_stage.get_drying_beds_of_lot(lot_id)).catch(e => {
    return handle401(e);
  });
};

export const getDryingBedChecks = async drying_lot_id => {
  return getAPI(routes.backend.drying_stage.get_drying_bed_checks(drying_lot_id)).catch(e => {
    return handle401(e);
  });
};

export const addDryingBedToExistingLot = async data => {
  return putAPI(routes.backend.drying_stage.add_drying_bed_to_existing_lot, data).catch(e => {
    return handle401(e);
  });
};

export const addDryingCheck = async data => {
  return postAPI(routes.backend.drying_stage.add_drying_check, data).catch(e => {
    return handle401(e);
  });
};

export const updateDryingCheck = async data => {
  return putAPI(routes.backend.drying_stage.update_drying_check, data).catch(e => {
    return handle401(e);
  });
};

export const getDryingBedInfo = async id => {
  return getAPI(routes.backend.drying_stage.get_drying_bed_info(id)).catch(e => {
    return handle401(e);
  });
};

export const endDryingOnBed = async ({ dryingBedId, data }) => {
  return putAPI(routes.backend.drying_stage.end_drying_on_bed(dryingBedId), data).catch(e => {
    return handle401(e);
  });
};

export const endDrying = async ({ lotId, data }) => {
  return putAPI(`${routes.backend.drying_stage.end_drying}${lotId}`, data).catch(e => {
    return handle401(e);
  });
};

// Uploads
export const getSignedUrls = async data => {
  return postAPI(routes.backend.uploads.getSignedUrls, { files: data.files, folder: data.folder }).catch(e => {
    return handle401(e);
  });
};

export const deleteMedia = async filename => {
  return deleteAPI(routes.backend.uploads.deleteMedia, { filePaths: filename }).catch(e => {
    return handle401(e);
  });
};

// Storage Lot API
export const getStorageLots = async (q, page, limit) => {
  return getAPI(`${routes.backend.storage_lot.get_storage_lots}?search=${q}&page=${page}&limit=${limit}`).catch(e => {
    return handle401(e);
  });
};

export const createStorageLot = async data => {
  return postAPI(routes.backend.storage_lot.create_storage_lot, data).catch(e => {
    return handle401(e);
  });
};

export const updateStorageLot = async (data, id) => {
  return putAPI(routes.backend.storage_lot.update_storage_lot(id), data).catch(e => {
    return handle401(e);
  });
};
export const getStorageLotById = async id => {
  return getAPI(routes.backend.storage_lot.get_storage_lot_by_id(id)).catch(e => {
    return handle401(e);
  });
};

// Storage Consumption API
export const getStorageConsumptions = async id => {
  return getAPI(routes.backend.storage_lot.get_storage_consumptions(id)).catch(e => {
    return handle401(e);
  });
};

export const createStorageConsumption = async data => {
  return postAPI(routes.backend.storage_lot.create_storage_consumption, data).catch(e => {
    return handle401(e);
  });
};

export const updateStorageConsumption = async (data, id) => {
  return putAPI(routes.backend.storage_lot.update_storage_consumption(id), data).catch(e => {
    return handle401(e);
  });
};

// Master Table API
export const getVarietalList = async () => {
  return getAPI(routes.backend.masterTable.varietalList).catch(e => {
    return handle401(e);
  });
};

export const getAgentList = async () => {
  return getAPI(routes.backend.masterTable.agentList).catch(e => {
    return handle401(e);
  });
};

export const getDryingBeds = async () => {
  return getAPI(routes.backend.masterTable.dryingBeds).catch(e => {
    return handle401(e);
  });
};

// QR Scanner API
export const getQRResult = async qrUrl => {
  return getAPI(qrUrl).catch(e => {
    return handle401(e);
  });
};

export const getDryingBedInfoByBedPosition = async (bed_position, bed_number) => {
  return postAPI(routes.backend.drying_stage.get_drying_bed_info_by_bed_position, {
    bed_position,
    bed_number,
  }).catch(e => {
    return handle401(e);
  });
};
